import * as DictionaryConstants from "../../../../../../constants/DictionaryConstants";
import * as RoutePathConstants from "../../../../../../constants/RoutePathConstants";

export default {
  data () {
    return {};
  },
  methods: {},
  mounted () { }
};



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page-new/views/discount-details/discount-details.js